import { createTheme, type MantineColorsTuple } from "@mantine/core";

/** Enterprise palette */
export const veritrellisPalette = {
  shell: "#f4f5f7",
  surface: "#ffffff",
  violet: "#7950f2",
  text: "#1c1c2e",
  textMuted: "#6b7280",
  border: "#e5e7eb"
} as const;

/** Primary — violet #7950f2 at index 6. */
const brand: MantineColorsTuple = [
  "#f3f0ff",
  "#e5dbff",
  "#d0bfff",
  "#b197fc",
  "#9775fa",
  "#845ef7",
  "#7950f2",
  "#6741d9",
  "#5f3dc4",
  "#5235a8"
];

/** Neutral slate for secondary/muted uses. */
const slate: MantineColorsTuple = [
  "#f8f9fa",
  "#f1f3f5",
  "#e9ecef",
  "#dee2e6",
  "#ced4da",
  "#adb5bd",
  "#868e96",
  "#495057",
  "#343a40",
  "#212529"
];

export const veritrellisTheme = createTheme({
  primaryColor: "brand",
  colors: {
    brand,
    slate
  },
  defaultRadius: "md",
  fontFamily:
    '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
  headings: {
    fontWeight: "600",
    fontFamily:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    sizes: {
      h1: { fontSize: "2rem" },
      h2: { fontSize: "1.5rem" }
    }
  },
  components: {
    AppShell: {
      styles: {
        root: {
          backgroundColor: veritrellisPalette.shell
        },
        header: {
          backgroundColor: veritrellisPalette.surface,
          borderBottom: `1px solid ${veritrellisPalette.border}`
        },
        navbar: {
          backgroundColor: veritrellisPalette.surface,
          borderRight: `1px solid ${veritrellisPalette.border}`
        },
        main: {
          backgroundColor: veritrellisPalette.shell
        }
      }
    }
  }
});
